const GPS_MENSAGEM_PATTERN = /^88-(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/;
const GPS_COORDS_ONLY_PATTERN = /^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?);?$/;

export function formatNotificationMessage(mensagem) {
  if (!mensagem) return mensagem;

  const raw = String(mensagem).trim();
  const gpsMatch = raw.match(GPS_MENSAGEM_PATTERN);

  if (gpsMatch) {
    return `Posição GPS: ${gpsMatch[1]}, ${gpsMatch[2]}`;
  }

  const coordsOnlyMatch = raw.match(GPS_COORDS_ONLY_PATTERN);
  if (coordsOnlyMatch) {
    return `Posição GPS: ${coordsOnlyMatch[1]}, ${coordsOnlyMatch[2]}`;
  }

  return raw;
}
